<template>
  <v-data-table
    :loading="loading"
    :headers="dataTable.headers"
    :items="items"
    :options.sync="dataTable.options"
    :footer-props="$config.dataTableFooterProps"
    v-bind="$attrs"
    v-model="selectedItems"
    calculate-widths
    disable-sort>
    <template #[`item.data-table-select`]="{ item, isSelected, select }">
      <v-checkbox
        v-if="!item.email_sent"
        :value="isSelected"
        @change="select"
        :disabled="!item.is_selectable" />
    </template>
    <template #[`item.barcode_number`]="{ item }">
      <div class="py-1">
        <div>{{ item.rf_id }}</div>
        <div>{{ item.barcode_number }}</div>
        <div v-if="item.email_sent">
          <v-icon small>mdi-email</v-icon>
          <span>{{ item.user?.name }} ({{ item.user?.email }})</span>
        </div>
      </div>
    </template>
    <template #[`item.name`]="{ item }">
      <v-text-field
        :disabled="!!item.email_sent"
        :error-messages="getError(item)?.name"
        v-model="item.name"
        filled
        dense
        placeholder="Név"
        persistent-placeholder />
    </template>
    <template #[`item.email`]="{ item }">
      <v-text-field
        :disabled="!!item.email_sent"
        :error-messages="getError(item)?.email"
        v-model="item.email"
        filled
        dense
        placeholder="E-mail cím"
        persistent-placeholder />
    </template>
    <template #[`item.plate`]="{ item }">
      <v-masked-text-field
        :disabled="!!item.email_sent"
        :error-messages="getError(item)?.license_plate"
        v-model="item.license_plate"
        :mask="$config.inputMasks.plateNumber"
        v-uppercase
        filled
        dense
        placeholder="Rendszám"
        persistent-placeholder />
    </template>
    <template #[`item.permissions`]="{ item }">
      <v-autocomplete
        :disabled="!!item.email_sent"
        :error-messages="getError(item)?.access_level_ids"
        v-model="item.access_level_ids"
        :value-comparator="$config.comparators.isEqual"
        :items="accessLevels"
        item-value="element_id"
        item-text="name"
        multiple
        filled
        small-chips
        dense
        @input="item.access_level_ids.sort((a, b) => (a > b ? 1 : -1))" />
    </template>
    <template #[`item.start_date_time`]="{ item }">
      <v-datetime-picker
        :disabled="!!item.email_sent"
        :time-picker="true"
        :date-picker="true"
        filled
        :error-messages="getError(item)?.start_date_time"
        v-model="item.start_date_time"
        clearable
        dense
        placeholder="Kezdő dátum"
        persistent-placeholder
        :allowed-from="new Date().setHours(new Date().getHours() + 1)"
        allow-seconds />
    </template>
    <template #[`item.period`]="{ item }">
      <v-masked-text-field
        :key="item.key"
        class="text-right"
        placeholder="Időtartam"
        persistent-placeholder
        filled
        :disabled="!!item.email_sent || lockPeriods"
        :error-messages="getError(item)?.period"
        dense
        v-model="item.period"
        :mask="$config.inputMasks.createNumberMask({ min: 1, max: 168 })"
        :suffix="item.period ? 'óra' : ''" />
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'TabCodes',

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    accessLevels: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Object,
      default: () => {},
    },
    lockPeriods: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      dataTable: {
        options: {
          itemsPerPage: 50,
        },
        headers: [
          { text: 'Rf ID / Szám', value: 'barcode_number' },
          { text: 'Kedvezményezett neve', value: 'name' },
          { text: 'Kedvezményezett email címe', value: 'email' },
          { text: 'Rendszám', value: 'plate', width: 200 },
          { text: 'Jogosultság', value: 'permissions' },
          { text: 'Kezdő dátum', value: 'start_date_time', width: 210 },
          { text: 'Időtartam (óra)', value: 'period', width: 120 },
        ],
      },
      selectedItems: [],
      loading: false,
    };
  },

  watch: {
    value(val) {
      this.selectedItems = val;
    },

    selectedItems(val) {
      this.$emit('input', val);
    },
  },

  methods: {
    getError(item) {
      if (this.errors[item.id]) {
        console.log(this.errors[item.id]);
        return this.errors[item.id];
      }
      return null;
    },
  }
};
</script>